<script>
    import { Line, mixins } from 'vue-chartjs'
    const { reactiveProp } = mixins
export default {
  extends: Line,
    mixins: [reactiveProp],
    props: ['options'],
  data () {
    return {
        /*datacollection: {
          labels: ['Day 1', 'Day 2', 'Day 3', 'Day 4', 'Day 5', 'Day 6'],
          datasets: [{
            label: '# of Votes',
            data: [10, 19, 3, 5, 2, 3],
            borderColor: [
              'rgba(255,99,132,1)'
            ],
            borderWidth: 1,
            fill: false
          }]
      },*/
      /*options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }]
        },
        legend: {
          display: true
        },
        elements: {
          point: {
            radius: 0
          }
        }
      }*/
    }
  },
  watch: {
    options: function(oldvalue, newvalue) {
      if(oldvalue !== newvalue) {
        this.renderChart(this.chartData, this.options)
      }
      //this.$data._chart.update()
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },

}
</script>
